import * as React from 'react';

interface AlertDialogProps {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  children: React.ReactNode;
}

export const AlertDialog: React.FC<AlertDialogProps> = ({ open, onOpenChange, children }) => {
  if (!open) return null;
  
  const handleClose = () => {
    if (onOpenChange) onOpenChange(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" role="alertdialog" aria-modal="true">
      <div className="fixed inset-0 bg-black/30" onClick={handleClose} />
      <div
        className="relative bg-white rounded-lg shadow-lg p-6 max-w-sm w-full"
        onClick={e => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export const AlertDialogContent: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => (
  <div className={`relative ${className || ''}`}>{children}</div>
);

export const AlertDialogHeader: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="mb-4">{children}</div>
);

export const AlertDialogTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <h2 className="text-lg font-semibold">{children}</h2>
);

export const AlertDialogDescription: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="text-sm text-gray-600 mt-2">{children}</p>
);

export const AlertDialogFooter: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="flex gap-2 mt-6 justify-end">{children}</div>
);

export const AlertDialogAction: React.FC<{ children: React.ReactNode; onClick: () => void; className?: string; disabled?: boolean }> = ({ children, onClick, className, disabled }) => (
  <button onClick={onClick} disabled={disabled} className={`px-3 py-2 bg-red-600 text-white rounded disabled:opacity-50 ${className || ''}`}>
    {children}
  </button>
);

export const AlertDialogCancel: React.FC<{ children: React.ReactNode; onClick: () => void; className?: string; disabled?: boolean }> = ({ children, onClick, className, disabled }) => (
  <button onClick={onClick} disabled={disabled} className={`px-3 py-2 bg-gray-200 text-gray-800 rounded disabled:opacity-50 ${className || ''}`}>
    {children}
  </button>
);
